export var SortDirectionEnum;
(function (SortDirectionEnum) {
    SortDirectionEnum["DESC"] = "DESC";
    SortDirectionEnum["ASC"] = "ASC";
})(SortDirectionEnum || (SortDirectionEnum = {}));
//# sourceMappingURL=sort-direction.enum.js.map